// ВСТАВКА РАСШИФРОВКИ В ПОЛЕ — чистая логика одной записи. Г-4 пп. 2 и 4.
//
// Запись владеет одним ОТРЕЗКОМ поля: начинается там, где стоял курсор (нет курсора — в конце), и
// растёт черновиками кусков. После «стоп» финальный текст ЗАМЕНЯЕТ весь отрезок (`s988.d5`).
//
// ⭐ ПРАВКУ ЧЕЛОВЕКА НЕ ЗАТИРАЕМ (`s994.d3`). Отрезок помнит, каким было поле после нашей последней
// записи (`expect`). Поле стало другим — значит правил человек: финал не вставляется вовсе, а
// следующие черновики дописываются в КОНЕЦ поля, ничего не заменяя.
//
// ⭐ КАП ЧЕРЕЗ `pasteInto` (`deckField.js`, `s824.d2`): режется ВСТАВКА, а не поле — приход в середину
// полного поля не съедает написанный хвост.
//
// Повторный тап дописывает (`s908.d3`): новая запись — новый отрезок с курсора/конца, старый текст цел.

import { pasteInto } from '../steps/deckField.js';

/** Отрезок новой записи в поле `value`; `caret` — позиция курсора (или `null`). */
export function startSegment(value, caret = null) {
  const text = typeof value === 'string' ? value : '';
  const at = Number.isInteger(caret) ? Math.max(0, Math.min(caret, text.length)) : text.length;
  return { at, len: 0, expect: text, edited: false, drafts: [] };
}

/** Пробелы на стыках: слово к слову не клеим, лишних не ставим. */
function framed(head, body, tail) {
  if (!body) return '';
  const lead = head && !/\s$/.test(head) ? ' ' : '';
  const trail = tail && !/^\s/.test(tail) ? ' ' : '';
  return `${lead}${body}${trail}`;
}

/** Заменить содержимое отрезка на `body`. Возвращает новое значение поля и отрезок. */
function replaceSegment(value, seg, body) {
  const head = value.slice(0, seg.at);
  const tail = value.slice(seg.at + seg.len);
  const piece = framed(head, body.trim(), tail);
  const next = pasteInto(value, piece, seg.at, seg.at + seg.len);
  const len = next.length - (value.length - seg.len);
  return { value: next, seg: { ...seg, len, expect: next } };
}

/** Дописать в конец поля (после правки человека). */
function appendAtEnd(value, seg, body) {
  const piece = framed(value, body.trim(), '');
  const next = pasteInto(value, piece, value.length, value.length);
  return { value: next, seg: { ...seg, expect: next } };
}

/**
 * Пришёл черновик куска. `value` — текущее значение поля.
 * @returns {{value: string, seg: object}}
 */
export function withDraft(value, seg, text) {
  const t = typeof text === 'string' ? text.trim() : '';
  const cur = typeof value === 'string' ? value : '';
  if (!t) return { value: cur, seg };
  if (seg.edited || cur !== seg.expect) {
    return appendAtEnd(cur, { ...seg, edited: true }, t);
  }
  const drafts = [...seg.drafts, t];
  return replaceSegment(cur, { ...seg, drafts }, drafts.join(' '));
}

/**
 * Пришёл финал. Человек правил поле — финал не вставляется (`applied: false`), поле как есть.
 * Пустой финал при непустых черновиках — тоже не вставляем: черновик лучше пустоты.
 */
export function withFinal(value, seg, text) {
  const cur = typeof value === 'string' ? value : '';
  const t = typeof text === 'string' ? text.trim() : '';
  if (seg.edited || cur !== seg.expect || (!t && seg.drafts.length)) return { value: cur, seg, applied: false };
  const out = replaceSegment(cur, seg, t);
  return { ...out, applied: true };
}
